/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  CreateConditionalOrderOptions,
  CreateConditionalOrderResponses,
} from '../types/CreateConditionalOrder'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Create a new conditional orders
 * {@link /v1/orders/conditional}
 */
export function createConditionalOrder<ThrowOnError extends boolean = true>(
  options: Options<CreateConditionalOrderOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateConditionalOrderResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/orders/conditional',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateConditionalOrderResponses, ThrowOnError>>,
  )
}
